module.exports = __webpack_public_path__ + "images/campaign-banner_e472e1a837c9ac40500bbf5793da9cb7.png";